import z from 'zod'

import { ENDPOINT } from '@/config/endpoint'
import { apiFactory, apiOk } from '@/libs/api'

import * as dto from '../schema/product-category-schema'

export const productCategoryApi = {
  list: apiFactory({
    url: ENDPOINT.product.category.list,
    method: 'get',
    schema: {
      params: z.custom<{ outletId: string }>(),
      result: apiOk(z.object({ categories: dto.ProductCategorySelectDto.array() })),
    },
  }),
  detail: apiFactory({
    url: ENDPOINT.product.category.detail,
    method: 'get',
    schema: {
      params: z.custom<{ id: string }>(),
      result: apiOk(z.object({ category: dto.ProductCategorySelectDto })),
    },
  }),
  create: apiFactory({
    url: ENDPOINT.product.category.create,
    method: 'post',
    schema: {
      body: z.custom<dto.ProductCategoryBodyDto>(),
      result: apiOk(z.unknown()),
    },
  }),
  update: apiFactory({
    url: ENDPOINT.product.category.update,
    method: 'put',
    schema: {
      body: z.custom<dto.ProductCategoryBodyDto & { id: string }>(),
      result: apiOk(z.unknown()),
    },
  }),
}
